'use strict';

var _             = require('underscore');
var $             = require('jquery');
var Core          = require('../core/core.js');
// var TopNavVersion = require('./topnav__version.js');

/**
 * Creates a connection area in a menu
 *
 * @param {String} [options.target=.js-sitemenu__right]
 * @param {String} [options.fields.message='Started']
 * @param {String} [options.fields.type='normal']
 * @class
 */

class TopNavConnection extends Core {

	_defaults() {
		return {
			target: '.js-sitemenu__right',
			fields: {
				'message': 'Started',
				'type': 'normal'
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__topnav__connection-menu">
                <div class='float'><span class='js-message'></span>
               
			</div>
		`;

		super.render();

        // hide versions icon by default
        
	}

	/**
	 * Set the connection menu to a certain value
	 * @param {String} message - The connection message
	 * @param {String} [type="normal"] - The type of connection,
	 *						  can be "normal", "warning" or "error"
	 * @returns none
	 */

	setConnectionMessage(message, type) {
		if(_.isUndefined(type)){
			var type = 'normal';
		}

        this.$el.removeClass("editor__topnav__connection-menu--warning editor__topnav__connection-menu--error editor__topnav__connection-menu--normal");

        if(type == 'warning'){
            $('.js-message', this.$el).html(message);
            this.$el.addClass("editor__topnav__connection-menu--warning");
        }else if(type == 'error'){
            $('.js-message', this.$el).html(message);
            this.$el.addClass("editor__topnav__connection-menu--error");
        }else{
            $('.js-message', this.$el).html(message);
            this.$el.addClass("editor__topnav__connection-menu--normal");
        }
	}

    /**
     * Add a connection version area to the menu
     * @param {String} message - The version name
     */

    // addVersionMenu(){
    //     //this.$el.addClass('editor__topnav__version');
    //     $('.js-versions', this.$el).on('click', this._clicked);
    // }

    // _clicked(e){
    //     e.preventDefault();
    //     $(e.currentTarget).trigger('Cioui:VersionMessage:click', e);
    // }

    // setVersionMessage(message, type) {
    
    //     $('.js-versions', this.$el).html(message);
    
    // }

}
module.exports = TopNavConnection;